import { Fragment, ReactElement, useMemo } from 'react';
import { DetailNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { DetailNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { DetailNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { DetailNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { DetailNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import DetailNotificationsShared from '../../research-notifications/detail';

interface DetailNotificationsCivilStatusSharedProps {
  scope?: string;
}

const DetailNotificationsCivilStatusShared = ({
  scope,
}: DetailNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();
  const idCat = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return DetailNotificationsCivilStatusCrumbs(idCat);
    }

    if (!scope) {
      return DetailNotificationsCrumbs;
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return DetailNotificationsSubscriptionCrumbs;
      case IdAmbito.Mutazioni:
        return DetailNotificationsMutationCrumbs;
      case IdAmbito.Cancellazioni:
        return DetailNotificationsCancellationsCrumbs;
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <DetailNotificationsShared items={items} baseUrl={baseUrl} />
    </Fragment>
  );
};

DetailNotificationsCivilStatusShared.displayName = 'Detail Notifications Civil Status component';

export default DetailNotificationsCivilStatusShared;
